import React from 'react';
import { SvgIcon } from '@material-ui/core'

const PediatricDivision = (props) => (
  <SvgIcon
    viewBox="0 0 29.66 36.505"
    {...props}
  >
    <path 
      d="M73.779,265.339a4.578,4.578,0,0,0-6.653.2,6.845,6.845,0,0,0-13.685,0,4.568,4.568,0,1,0-6.653,6.256L52.3,277.3v14.081a4,4,0,0,0,3.993,3.993h1.141a3.985,3.985,0,0,0,2.852-1.2,3.981,3.981,0,0,0,2.851,1.2h1.141a4,4,0,0,0,3.993-3.993V277.3l5.51-5.508a4.569,4.569,0,0,0,0-6.453Zm-13.5-4.189a4.563,4.563,0,1,1-4.563,4.563A4.563,4.563,0,0,1,60.283,261.151Zm11.88,9.028-6.177,6.177v15.025a1.711,1.711,0,0,1-1.711,1.712H63.135a1.711,1.711,0,0,1-1.711-1.712V283.4H59.142v7.985a1.711,1.711,0,0,1-1.711,1.712H56.291a1.711,1.711,0,0,1-1.712-1.712V276.356L48.4,270.179a2.282,2.282,0,1,1,3.227-3.227l5.606,5.606h6.1l5.606-5.606a2.282,2.282,0,1,1,3.227,3.227Z" 
      transform="translate(-45.453 -258.869)"
    />
  </SvgIcon>
);

export default PediatricDivision;